
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns5cec31d0bd29739533eccbd99edbafc1en from './en.yaml'
            i18n.addResourceBundle('en', '5cec31d0bd29739533eccbd99edbafc1', flattenObject(ns5cec31d0bd29739533eccbd99edbafc1en), true, true);
        
        export default '5cec31d0bd29739533eccbd99edbafc1';
    